export default __webpack_public_path__ + "oval.9184a6.svg";